/* Keyboard shortcuts reference dialog. Opened via Cmd+/, the View menu,
   or the ? button in the status bar. Static catalog — update when adding shortcuts. */

const SHORTCUTS = [
  { group: 'Editor', items: [
    { label: 'Save current tab (validates Python)', keys: ['⌘', 'S'] },
    { label: 'Run script in Script Workbench',     keys: ['⌘', '⏎'] },
    { label: 'Validate syntax',                     keys: ['⌘', '⇧', 'V'] },
    { label: 'Open editor overflow menu (⋯)',       keys: ['⌘', '⇧', 'M'] },
  ]},
  { group: 'Workspace', items: [
    { label: 'Toggle left sidebar (Explorer)',      keys: ['⌘', 'B'] },
    { label: 'Toggle bottom panel (Console)',       keys: ['⌘', 'J'] },
    { label: 'Open View menu',                      keys: ['⌘', '⇧', 'P'] },
    { label: 'Find in files',                       keys: ['⌘', '⇧', 'F'] },
  ]},
  { group: 'Chat', items: [
    { label: 'Send message',                        keys: ['⏎'] },
    { label: 'Newline in chat input',               keys: ['⇧', '⏎'] },
    { label: 'Reference a file',                    keys: ['@'] },
    { label: 'Open slash-command picker',           keys: ['/'] },
  ]},
  { group: 'General', items: [
    { label: 'Show this dialog',                    keys: ['⌘', '/'] },
    { label: 'Close dialog / blur input',           keys: ['Esc'] },
  ]},
];

let _dialogEl = null;

function _esc(s) { return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c])); }

function _renderKeys(keys) {
  return keys.map((k, i) => {
    const sep = i > 0 ? '<span class="sd-plus">+</span>' : '';
    return `${sep}<span class="sd-key">${_esc(k)}</span>`;
  }).join('');
}

function _renderDialog() {
  const groups = SHORTCUTS.map(g => `
    <div class="sd-group">
      <h4>${_esc(g.group)}</h4>
      ${g.items.map(it => `
        <div class="sd-row">
          <span>${_esc(it.label)}</span>
          <span class="sd-keys">${_renderKeys(it.keys)}</span>
        </div>
      `).join('')}
    </div>
  `).join('');

  const backdrop = document.createElement('div');
  backdrop.className = 'shortcuts-dialog-backdrop';
  backdrop.innerHTML = `
    <div class="shortcuts-dialog" role="dialog" aria-label="Keyboard shortcuts">
      <button class="sd-close" aria-label="Close"><i class="ic ic-sm ic-x"></i></button>
      <h3>Keyboard shortcuts</h3>
      <div class="sd-sub">Press <span class="sd-key">⌘</span><span class="sd-plus">+</span><span class="sd-key">/</span> any time to reopen this.</div>
      ${groups}
    </div>
  `;
  return backdrop;
}

function _close() {
  if (_dialogEl && _dialogEl.parentNode) _dialogEl.parentNode.removeChild(_dialogEl);
  _dialogEl = null;
  document.removeEventListener('keydown', _onKey, true);
}

function _onKey(e) {
  if (e.key === 'Escape') { e.preventDefault(); _close(); }
}

export function openShortcutsDialog() {
  if (_dialogEl) { _close(); return; }
  _dialogEl = _renderDialog();
  document.body.appendChild(_dialogEl);

  _dialogEl.addEventListener('mousedown', (e) => {
    // Close on backdrop click but not when clicking the dialog itself
    if (e.target === _dialogEl) _close();
  });
  _dialogEl.querySelector('.sd-close')?.addEventListener('click', _close);
  document.addEventListener('keydown', _onKey, true);
}

export function isShortcutsDialogOpen() {
  return !!_dialogEl;
}
